export const DEFAULT_LANG = 'en';

export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  hu: 'Hungarian',
  de: 'German',
  sk: 'Slovak',
  fr: 'French',
  es: 'Spanish',
  it: 'Italian',
  pl: 'Polish',
  ro: 'Romanian',
  cs: 'Czech',
  nl: 'Dutch',
};

export const SELECTABLE_LANGUAGES = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'hu', label: 'HU', flag: '🇭🇺' },
  { code: 'de', label: 'DE', flag: '🇩🇪' },
  { code: 'sk', label: 'SK', flag: '🇸🇰' },
] as const;

export type SupportedLang = (typeof SELECTABLE_LANGUAGES)[number]['code'];

export function normalizeLang(input?: string | null): string {
  const lang = input?.toLowerCase().trim().slice(0, 2);
  return lang && /^[a-z]{2}$/.test(lang) ? lang : DEFAULT_LANG;
}

export function isDefaultLang(lang: string): boolean {
  return normalizeLang(lang) === DEFAULT_LANG;
}

export function getLanguageName(lang: string): string {
  const normalized = normalizeLang(lang);
  return LANGUAGE_NAMES[normalized] ?? `the ISO-639-1 language code ${normalized}`;
}
